
import img1 from '../images/svg/icon-1.svg'
import img2 from '../images/svg/icon-2.svg'
import img3 from '../images/svg/icon-3.svg'
import img4 from '../images/svg/icon-4.svg'



const dataPortfolio = [

    {
        id: 1,
        img: img1,
        title: 'Register With Us.',
        desc: "Register to compete in exciting PUBG Mobile matches and win amazing prizes! Enjoy secure gameplay, fair competition, and hassle-free prize distribution."    },
    {
        id: 2,
        img: img2,
        title: 'Deposit PKR.',
        desc: "Easily deposit money using EasyPaisa to join thrilling PUBG Mobile matches. Compete, win, and get your prizes quickly and securely! "  },
    {
        id: 3,
        img: img3,
        title: 'Daily New Matches',
        desc: 'Join daily new PUBG Mobile matches and showcase your skills against top players. Find matches as low as 100 PKR.'
    },
    {
        id: 4,
        img: img4,
        title: 'Withdraw Prizes',
        desc: 'Easily withdraw your winnings through EasyPaisa for quick and secure transactions. Enjoy hassle-free payouts after every victorious match!, All payouts are given within 5 minutes of request.'   },


]

export default dataPortfolio;